import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import { Link } from 'react-router-dom';
import './AboutJoinSection.scss';

import joinImage from '../../../../assets/images/about/join-about.webp';

const AboutJoinSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const slideLeft = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, x: -40 },
              whileInView: { opacity: 1, x: 0 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.2, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="about-join">
            <div className="about-join__container">
                <div className="about-join__grid">
                    
                    <div className="about-join__image-col">
                        <motion.img
                            src={joinImage}
                            alt={t('alt_church_community')}
                            className="about-join__image"
                            {...slideLeft}
                        />
                    </div>

                    <div className="about-join__content">
                        <motion.h2 className="about-join__title" {...fadeUp(0, 1.1)}>{t('join_us_sunday')}</motion.h2>
                        <motion.p className="about-join__description" {...fadeUp(0.15)}>
                            {t('join_description')}
                        </motion.p>
                        <motion.div {...fadeUp(0.3, 0.9)}>
                            <Link to="/join" className="about-join__button">
                                {t('attend_service')}
                            </Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutJoinSection;